import { AssignmentTurnedIn, BorderColor, Handshake, Info } from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, CardContent, CardHeader, Container, CssBaseline, Grid, IconButton, Stack, Tab, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import MyBreadcrumbs from "../../../../components/MyBreadcrumbs";
import MyDialog from "../../../../components/MyDialog";
import MyTable from "../../../../components/MyTable";
import { AuthStore } from "../../../../store/UserStore";
import { base_url } from "../../../../utils/GlobalVariables";
import { CustomDescrypt } from "../../../../utils/MyEncryption";
import { DataSp2dDiserahkan } from "../sp2d_diserahkan/Index";
import { DataTtdSp2d } from "../TtdSp2d/Index";

const ProsesSp2d = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Proses SP2D" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [value, setValue] = useState('1');
    const [dialogData, setDialogData] = useState({});
    const [openDialog, setOpenDialog] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        setBreadcrumbItem({ '/admin': 'Home', '': 'Proses SP2D' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {

                const handleOpenDialog = () => {
                    // console.log(data);
                    setDialogData(params.row)
                    setOpenDialog(true);
                };

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Detail">
                            <IconButton aria-label="edit" color="info" onClick={handleOpenDialog}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            }
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = () => {
        console.log('req data');
        setTableLoading(true)
        axios.get(
            base_url + '/admin/pencairan/proses_sp2d',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Card>
            <CardHeader
                title="Proses SP2D"
            />
            <CardContent>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab icon={<AssignmentTurnedIn />} label="SPM Valid" value="1" />
                                <Tab icon={<BorderColor />} label="SP2D Ditandatangani" value="2" />
                                <Tab icon={<Handshake />} label="SP2D Diserahkan" value="3" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <MyTable
                                rows={tableData}
                                columns={columns}
                                row_id={(row) => row.no_spm}
                                isLoading={tableLoading}
                            />
                        </TabPanel>
                        <TabPanel value="2">
                            <DataTtdSp2d />
                        </TabPanel>
                        <TabPanel value="3">
                            <DataSp2dDiserahkan />
                        </TabPanel>
                    </TabContext>
                </Box>
            </CardContent>
            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />
        </Card>
    )
}

export default ProsesSp2d
export { Data as DataProsesSp2d }